module.exports = __webpack_public_path__ + "static/media/grayscale.1bd27c03.jpg";